import ATE from "./ActionTypeEnum";
import IAppState from "./IAppState";
import IInputFile from "./pages/SummaryPage/interfaces/IInputFile";
import IDT from "./pages/InputPage/interfaces/InputDataType";

import CALC from "./pages/InputPage/interfaces/Calculation";
import IMainState from "./IMainState";


export default {

    setAppState: (appState: IAppState) => ({
        type: ATE.SET_APP_STATE,
        value: appState,
    }),

    setMainState: (updater: Partial<IMainState>) => ({
        type: ATE.SET_MAIN_STATE,
        value: updater,
    }),

    resetMainState: () => ({
        type: ATE.RESET_MAIN_STATE,
    }),

    setInitialInputState: () => ({
        type: ATE.SET_INITIAL_INPUT_STATE,
    }),

    clickFindJobBtn: (jobId: string) => ({
        type: ATE.CLICK_FIND_JOB_BTN,
        value: jobId,
    }),

    changejobTitle: (jobTitle: string) => ({
        type: ATE.CHANGE_JOB_TITLE_FIELD,
        value: jobTitle,
    }),

    /*changeMMSelection: (mm: string) => ({
        type: ATE.CHANGE_MM_SELECTION,
        value: mm,
    }),*/

    changeInputDataType: (inputDataType: IDT) => ({
        type: ATE.CHANGE_TYPE_INPUT_DATA,
        value: inputDataType,
    }),

    changeLowRiskDesign: () => ({
        type: ATE.CHANGE_LOW_RISK_DESIGN,
    }),

    toggleForceFieldMutations: () => ({
        type: ATE.TOGGLE_FORCE_FIELD_MUTATIONS
    }),

    toggleBFactorAnalysis: () => ({
        type: ATE.TOGGLE_B_FACTOR_ANALYSIS
    }),

    toggleConsensusMutations: () => ({
        type: ATE.TOGGLE_CONSENSUS_MUTATIONS
    }),

    groupAutomatedSinglePoint: () => ({
        type: ATE.GROUP_AUTOMATED_SINGLE_POINT
    }),

    groupAutomatedMultiplePoint: () => ({
        type: ATE.GROUP_AUTOMATED_MULTIPLE_POINT
    }),

    changeCalculation: (calc_type: CALC) => ({
        type: ATE.CHANGE_CALCULATION,
        value: calc_type,
    }),

    changeHighRiskDesign: () => ({
        type: ATE.CHANGE_HIGH_RISK_DESIGN
    }),

    setShowChainsSelection: (showChainsSelection: boolean) => ({
        type: ATE.SET_SHOW_CHAINS_SELECTION
    }),

    changeAncestralDesign: () => ({
        type: ATE.CHANGE_ANCESTRAL_RISK_DESIGN
    }),

    changeemail: (email: string) => ({
        type: ATE.CHANGE_EMAIL_FIELD,
        value: email,
    }),

    toggleModelling: () => ({
        type: ATE.TOGGLE_MODELLING,
    }),

    changemaxNumSeqField: (maxNumSeqFieldMP: number) => ({
        type: ATE.CHANGE_MAX_NUM_SEQ_FIELD,
        value: maxNumSeqFieldMP,
    }),

    changeblastEvalField : (blastEvalField: number) => ({
        type: ATE.CHANGE_BLAST_E_VAL_FIELD,
        value: blastEvalField,
    }),

    changeminIdentityField: (minIdentityField: number) => ({
        type: ATE.CHANGE_MIN_IDENTITY_FIELD,
        value: Math.max(0, Math.min(100, Number(minIdentityField))),
    }),

    changemaxIdentityField: (maxIdentityField: number) => ({
        type: ATE.CHANGE_MAX_IDENTITY_FIELD,
        value: Math.max(0, Math.min(100, Number(maxIdentityField))),
    }),
    // advanced settings : identification of consensus residues
    changeMajorityConsensusMinIdentity : (majorityConsensusMinIdentity: number) => ({
        type: ATE.CHANGE_MAJORITY_CONSENSUS_MIN_IDENTITY,
        value: majorityConsensusMinIdentity,
    }),

    changeRatioConsensusMinFreq : (ratioConsensusMinFreq: number) => ({
        type: ATE.CHANGE_RATIO_CONSENSUS_MIN_FREQ,
        value: Math.max(0, Math.min(100, Number(ratioConsensusMinFreq))),
    }),

    changeRatioConsensusMinRatio : (ratioConsensusMinRatio: number) => ({
        type: ATE.CHANGE_RATIO_CONSENSUS_MIN_RATIO,
        value: ratioConsensusMinRatio,
    }),

    changeGlobalConsensusGapThreshold : (globalConsensusGapThreshold: number) => ({
        type: ATE.CHANGE_GLOBAL_CONSENSUS_GAP_THRESHOLD,
        value: Math.max(0, Math.min(100, Number(globalConsensusGapThreshold))),
    }),
    // END advanced settings : identification of consensus residues

    // advanced settings : threshold settings

    changeLimitForceFields: (limitForceFields: boolean) => ({
        type: ATE.CHANGE_LIMIT_FORCE_FIELD,
        value: limitForceFields,
    }),


    changeEvolutionFoldXThreshold : (evolutionFoldXThreshold: number) => ({
        type: ATE.CHANGE_EVOLUTION_FOLD_X_THRESHOLD,
        value: evolutionFoldXThreshold,
    }),

    changeEnergyFoldXThreshold : (energyFoldXThreshold: number) => ({
        type: ATE.CHANGE_ENERGY_FOLD_X_THRESHOLD,
        value: energyFoldXThreshold,
    }),

    changeEnergyRosettaThreshold : (energyRosettaThreshold: number) => ({
        type: ATE.CHANGE_ENERGY_ROSETTA_THRESHOLD,
        value: energyRosettaThreshold,
    }),

    changeMultipointRosettaThreshold : (multipointRosettaThreshold: number) => ({
        type: ATE.CHANGE_MULTIPOINT_ROSETTA_THRESHOLD,
        value: multipointRosettaThreshold,
    }),
    // END advanced settings : threshold settings

    // advanced settings : analysis of correlated positions
    changeZScoreThreshold : (zScoreThreshold: number) => ({
        type: ATE.CHANGE_Z_SCORE_THRESHOLD,
        value: zScoreThreshold,
    }),

    // END advanced settings : analysis of correlated positions

    changePdbIdField: (pdbIdField: string) => ({
        type: ATE.CHANGE_PDB_ID_FIELD,
        value: pdbIdField,
    }),

    changeUniprotIdField: (uniprotIdField: string) => ({
        type: ATE.CHANGE_UNIPROT_ID_FIELD,
        value: uniprotIdField,
    }),


    changePdbChainField: (pdbChainField: string) => ({
        type: ATE.CHANGE_PDB_CHAIN_FIELD,
        value: pdbChainField,
    }),
    
    changesequence: (sequence: string) => ({
        type: ATE.CHANGE_SEQUENCE_FIELD,
        value: sequence,
    }),

    addRemoveMutation: (pos: number, bas: string) => ({
        type: ATE.ADD_REMOVE_MUTATION,

        value: {position:pos,
            base: bas}
            
    }),

    RemoveMutationsOnPosition: (pos: number) => ({
        type: ATE.REMOVE_MUTATIONS_ON_POSITION,

        value: {position:pos}
            
    }),

    AddAllMutationsOnPosition: (pos: number, WTBase: string) => ({
        type: ATE.ADD_ALL_MUTATIONS_ON_POSITION,

        value: {position:pos, base: WTBase}
            
    }),

    loadInputFile: (data: IInputFile) => ({
        type: ATE.LOAD_INPUT_FILE,
        value: data,
    }),

    changeStructureInfo: (structureInfo: IMainState['processedStructure']) => ({
        type: ATE.CHANGE_STRUCTURE_INFO,
        value: structureInfo,
    }),

    setSelectedStructureInfo: (
        selectedStructureInfo: IMainState['selectedStructureInfo']
    ) => ({
        type: ATE.SET_SELECTED_STRUCTURE_INFO,
        value: selectedStructureInfo,
    }),

    setSelectedSiteAnotations: (
        selectedSitesAnotations: IMainState['selectedSiteAnotations']
    ) => ({
        type: ATE.SET_SELECTED_SITE_ANOTATIONS,
        value: selectedSitesAnotations,
    }),

    setSitesAnotations: (sitesAnotations: IMainState['sitesAnotations']) => ({
        type: ATE.SET_SITES_ANNOTATIONS,
        value: sitesAnotations,
    }),

    addCustomMutantMutations:(mutation: IMainState['CustomMutantMutations']) => ({
        type: ATE.ADD_CUSTOM_MUTANT_MUTATIONS,
        value: mutation,
    }),

    removeCustomMutantMutations:(mutation: IMainState['CustomMutantMutations']) => ({
        type: ATE.REMOVE_CUSTOM_MUTANT_MUTATIONS,
        value: mutation,
    }),

    clearMutations:() => ({
        type: ATE.CLEAR_MUTATIONS,
    }),

    setResultsLoaded:(finished: boolean) => ({
        type: ATE.SET_JOB_FINISHED,
        value: finished
    }),

    setJobId: (jobId: string) => ({
        type: ATE.SET_JOB_ID,
        value: jobId,
    }),

}
